export const S3_ACTIONS = {
    FETCH_EN_VALIDATION_FILES: 'FETCH_EN_VALIDATION_FILES',
    FETCH_B2B_VALIDATION_FILES: 'FETCH_B2B_VALIDATION_FILES',
    FETCH_B2B_RENEWAL_FILES: 'FETCH_B2B_RENEWAL_FILES',
    GET_FILE_DOWNLOAD_URL: 'GET_FILE_DOWNLOAD_URL',
    DOWNLOAD_START: 'DOWNLOAD_START',
    DOWNLOAD_SUCCESS: 'DOWNLOAD_SUCCESS',
    DOWNLOAD_ERROR: 'DOWNLOAD_ERROR'
} as const; 